/**
 * @desc 获取地址树
 */
import { AreaEntity, AreaTreeQuery } from '@eastcoal/api/system/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type QueryAreaTreeParameter = AreaTreeQuery

const method = 'GET'
const url = '/system/area/tree'

export const queryAreaTreeApi = (
  params?: QueryAreaTreeParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<Array<AreaEntity>>({
    method,
    url,
    params,
    ...config
  })
}

queryAreaTreeApi.method = method
queryAreaTreeApi.url = url
